import { useQuery } from "@tanstack/react-query";

import { fetchApplePaySession } from "checkout-query-client/api/fetch-apple-pay-session";

export const useApplePayClientSession = (
  checkoutSessionToken: string,
  apiHost: string,
  version: string,
  validationURL: string,
  hostName: string
) =>
  useQuery({
    queryKey: [
      {
        scope: "apple-pay-session",
        apiHost,
        version,
        checkoutSessionToken,
        validationURL,
        hostName,
      },
    ],
    queryFn: fetchApplePaySession,
    enabled: validationURL.length > 0,
  });
